import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light p-2" }, "Search Trainee Information")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Search by Trainee Registration Number", -1)
const _hoisted_10 = { class: "col-md-2 mt-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-4" }, "Trainee Attendance List", -1)
const _hoisted_14 = { class: "card mt-5 mb-xl-10" }
const _hoisted_15 = {
  class: "card-header border-0 cursor-pointer bg-success px-4 py-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_16 = { class: "card-title m-0" }
const _hoisted_17 = { class: "fw-bolder text-light m-0" }
const _hoisted_18 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
  ])
], -1)
const _hoisted_26 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_27 = { class: "collapse show" }
const _hoisted_28 = { class: "card-body border-top p-6" }
const _hoisted_29 = {
  class: "current",
  "data-kt-stepper-element": "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registration_number) = $event)),
                  type: "text",
                  name: "name",
                  class: "form-control",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, _ctx.registration_number]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getAttendanceDetails())),
                  type: "button",
                  class: "btn btn-success mt-4",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_11
                ])
              ])
            ]),
            (_ctx.showCourseNotice == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("h3", _hoisted_17, " Name:" + _toDisplayString(_ctx.detailsData.trainee_name) + " ,Total Attendance:" + _toDisplayString(_ctx.detailsDataAttendance.length), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("button", {
                          style: {"background-color":"#2a764d"},
                          type: "button",
                          class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                          title: "Download Xlse",
                          "data-v-54b12dc8": "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportTrainee()))
                        }, _hoisted_20),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Download PDF",
                          "data-v-54b12dc8": "",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadPdf()))
                        }, _hoisted_22),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Print",
                          "data-v-54b12dc8": "",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.printPdf()))
                        }, _hoisted_24)
                      ])
                    ]),
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_Datatable, {
                              "table-data": _ctx.detailsDataAttendance,
                              "table-header": _ctx.tableHeader,
                              "enable-items-per-page-dropdown": true
                            }, {
                              "cell-attendance_date": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(_ctx.moment(industry?.session_date).format(
                                'DD-MM-YYYY'
                              )), 1)
                              ]),
                              "cell-present": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.is_present ? 'Yes' : 'No'), 1)
                              ]),
                              "cell-late": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.is_late ? 'Yes' : 'No'), 1)
                              ]),
                              "cell-inTime": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(_ctx.moment(industry?.in_time, 'hh:mm').format('LT')), 1)
                              ]),
                              "cell-out_time": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(_ctx.moment(industry?.out_time, 'hh:mm').format('LT')), 1)
                              ]),
                              "cell-term_no": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.term_no), 1)
                              ]),
                              remarks: _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.remarks), 1)
                              ]),
                              _: 1
                            }, 8, ["table-data", "table-header"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}